import { Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, title, sub, align = "center", dark = false }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className={`font-mono-data text-xs font-medium uppercase tracking-[0.24em] ${dark ? "text-red-400" : "text-[#b91c1c]"}`}>
        {eyebrow}
      </p>
    )}
    <h2
      className={`mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${
        dark ? "text-white" : "text-slate-900"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 text-base leading-relaxed md:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>{sub}</p>
    )}
  </Reveal>
);
